// extracted by mini-css-extract-plugin
module.exports =  {"root":"jNZbLT","colorPickerItem":"ntuavi","colorPickerItemRemaining":"P5TFmm","remainingColorsCounter":"KpWcbw","separateStyles":"h26miP"};